"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reporter = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("./types");
var notifyEvents_1 = require("./constants/notifyEvents");
var event_1 = require("./utils/event");
var Reporter = /** @class */ (function () {
    function Reporter() {
        this.enterTime = Date.now();
    }
    Reporter.prototype.init = function (config) {
        if (config.enabled === false) {
            return;
        }
        this.sendToSaService.init();
        this.clickEventService.monitor();
        this.clickEventService.subscribe(this.clickEventObserver);
        this.inputEventService.monitor();
        this.inputEventService.subscribe(this.inputEventObserver);
        this.pasteEventService.monitor();
        this.pasteEventService.subscribe(this.pasteEventObserver);
        this.observableService.subscribe(notifyEvents_1.NOTIFY_SA_CLICK_EVENT, this.clickService);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_LEAVE, this);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_RE_ENTER, this);
        this.observableService.subscribe(notifyEvents_1.NOTIFY_SA_INPUT_EVENT, this.inputService);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_EXPOSE_ITEMS, this.exposeEventObserver);
        this.visibilityEventService.subscribe(this.visibilityEventObserver);
        this.localStoreService.init(config.appName || "aku", "saLocalStore");
        this.sessionStoreService.init(config.appName || "aku", "saSessionStore");
        this.eventOrderBucket.init(this.localStoreService);
        this.setSdkConfig(__assign(__assign({}, config), { autoTrack: !!config.autoTrack, enabled: typeof config.enabled === "undefined" ? true : config.enabled, appName: config.appName || "Akulaku", prefix: config.prefix || "Aku", filterEventObj: config.filterEventObj || {
                enabled: false,
                eventArr: [],
            } }));
        this.sensorAnalyticsService.init(config);
    };
    Reporter.prototype.setSdkConfig = function (config) {
        this.sdkConfigService.set({
            env: config.env,
            autoTrack: config.autoTrack,
            enabled: config.enabled,
            prefix: config.prefix,
            appName: config.appName,
            appVersion: config.appVersion,
            userId: config.userId,
            countryId: config.countryId,
            countryCode: config.countryCode,
            filterEventObj: config.filterEventObj || {
                enabled: false,
                eventArr: [],
            },
            sessionIdKey: config.sessionIdKey,
            deviceId: config.deviceId,
            adjustId: config.adjustId,
            googleAdId: config.googleAdId,
            deviceUuid: config.deviceUuid,
            disableVisibilityHandler: config.disableVisibilityHandler,
        });
    };
    Reporter.prototype.updateSdkConfig = function (config) {
        this.sdkConfigService.update(config);
    };
    Reporter.prototype.setPageConfig = function (config) {
        this.pageConfigService.set(config);
    };
    Reporter.prototype.getPageConfig = function () {
        return this.pageConfigService.get();
    };
    Reporter.prototype.enter = function (data) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
            var sessionExpired, eventName, reportData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data) {
                            return [2 /*return*/];
                        }
                        this.eventOrderBucket.resetInputOrder();
                        this.eventOrderBucket.resetInputOrders();
                        this.eventOrderBucket.resetPasteInputs();
                        return [4 /*yield*/, this.sessionService.isExpired()];
                    case 1:
                        sessionExpired = _a.sent();
                        if (!sessionExpired) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.eventOrderBucket.resetClickOrder()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        eventName = (0, event_1.resolveEventName)(data, types_1.EventType.View);
                        reportData = __assign(__assign({}, data), { eventType: eventName, page_view_type: "Enter" });
                        this.sendToSaService.dispatch({
                            list: [reportData],
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Reporter.prototype.leave = function (data) {
        var _this = this;
        if (!data) {
            return;
        }
        this.applicationExecutor.callWhenPrepared(function () {
            var now = Date.now();
            var eventName = (0, event_1.resolveEventName)(data, types_1.EventType.View);
            var reportData = __assign(__assign({}, data), { eventType: eventName, duration: now - _this.enterTime, page_view_type: "Leave" });
            _this.sendToSaService.dispatch({
                list: [reportData],
            });
        });
    };
    Reporter.prototype.click = function (data, event) {
        this.clickService.click(__assign(__assign({}, data), { event: types_1.EventType.Click }), event);
    };
    Reporter.prototype.popClick = function (data, event) {
        this.clickService.click(__assign(__assign({}, data), { event: types_1.EventType.PopClick }), event);
    };
    Reporter.prototype.expose = function (data) {
        // if (!data) {
        //   return;
        // }
        // this.sendToSaService.dispatch({
        //   list: [
        //     {
        //       ...data,
        //       eventType: resolveEventName(data, EventType.Expose),
        //     },
        //   ],
        // });
    };
    Reporter.prototype.input = function (data) {
        var _this = this;
        if (!data) {
            return;
        }
        this.applicationExecutor.callWhenPrepared(function () {
            _this.inputService.input(data);
        });
    };
    // enableAutoExpose(): void {
    //   this.exposeService.enable();
    // }
    // stopExposeMonitor(): void {
    //   this.exposeService.stop();
    // }
    // reCollectExposeItems(): void {
    //   this.exposeService.reCollect();
    // }
    // exposeAfterReCollect(config: IReCollectConfig): void {
    //   this.exposeService.exposeAfterReCollect(config);
    // }
    Reporter.prototype.subscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    Reporter.prototype.unsubscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    Reporter.prototype.login = function (userId) {
        this.sensorAnalyticsService.login(userId);
    };
    Reporter.prototype.logout = function (isChangeId) {
        this.sensorAnalyticsService.logout(isChangeId);
    };
    Reporter.prototype.track = function (event, data) {
        this.sensorAnalyticsService.track(event, data);
    };
    Reporter.prototype.trackWithPrefix = function (event, data) {
        this.sensorAnalyticsService.trackWithPrefix(event, data);
    };
    Reporter.prototype.update = function (data, eventType) {
        var _this = this;
        if (this.sdkConfigService.get().disableVisibilityHandler ||
            this.pageConfigService.get().disableVisibilityHandler) {
            return;
        }
        if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_LEAVE) {
            this.applicationExecutor.callWhenPrepared(function () {
                _this.prevLeave(data);
            });
        }
        else if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_RE_ENTER) {
            this.enter({});
        }
    };
    Reporter.prototype.prevLeave = function (data) {
        var now = Date.now();
        var eventName = (0, event_1.resolveEventName)(data, types_1.EventType.View);
        var createTime = data.createTime, uri = data.uri;
        var reportData = __assign(__assign({}, data), { eventType: eventName, duration: now - createTime, page_view_type: "Leave", uri: uri });
        this.sendToSaService.dispatch({
            list: [reportData],
        });
    };
    __decorate([
        (0, event_tracking_core_1.lazyInject)(event_tracking_core_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "observableService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(event_tracking_core_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], Reporter.prototype, "applicationExecutor", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IEventObservable, event_tracking_core_1.TAG.VisibilityEventService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "visibilityEventService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(event_tracking_core_1.TYPES.ISessionService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "sessionService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IEventObservable, event_tracking_core_1.TAG.ClickEventService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "clickEventService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IConfigService, types_1.TAG.SDKConfigService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "sdkConfigService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IConfigService, types_1.TAG.PageConfigService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "pageConfigService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(types_1.TYPES.ISensorAnalyticsService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "sensorAnalyticsService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(types_1.TYPES.ISendToSaService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "sendToSaService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IObserver, types_1.TAG.ClickEventObserver),
        __metadata("design:type", Object)
    ], Reporter.prototype, "clickEventObserver", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IObserver, types_1.TAG.VisibilityEventObserver),
        __metadata("design:type", Object)
    ], Reporter.prototype, "visibilityEventObserver", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IEventOrderBucket, types_1.TAG.EventOrderBucket),
        __metadata("design:type", Object)
    ], Reporter.prototype, "eventOrderBucket", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IStoreService, types_1.TAG.LocalStoreService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "localStoreService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IStoreService, types_1.TAG.SessionStoreService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "sessionStoreService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(types_1.TYPES.IClickService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "clickService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IEventObservable, event_tracking_core_1.TAG.InputEventService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "inputEventService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IEventObservable, event_tracking_core_1.TAG.PasteEventService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "pasteEventService", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IObserver, types_1.TAG.InputEventObserver),
        __metadata("design:type", Object)
    ], Reporter.prototype, "inputEventObserver", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IObserver, types_1.TAG.PasteEventObserver),
        __metadata("design:type", Object)
    ], Reporter.prototype, "pasteEventObserver", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInjectNamed)(event_tracking_core_1.TYPES.IObserver, types_1.TAG.ExposeEventObserver),
        __metadata("design:type", Object)
    ], Reporter.prototype, "exposeEventObserver", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(types_1.TYPES.IInputService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "inputService", void 0);
    Reporter = __decorate([
        (0, inversify_1.injectable)(),
        __metadata("design:paramtypes", [])
    ], Reporter);
    return Reporter;
}());
exports.Reporter = Reporter;
